import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { Image, P, Btn } from "../../../../../../AbstractElements";
import { dynamicImage } from "../../../../../../Utils";
import DashboardSvgIcon from "../../../../../../Utils/CommonComponents/DashboardSvgIcon";
import SimpleMdeReact from "react-simplemde-editor";
import { LetterAttachment } from "../../../../../../Features/letterBox/api/types";

export default function UserFooter({ attachments }: { attachments: LetterAttachment[] }) {
  const [downloadingIds, setDownloadingIds] = useState<number[]>([]);
  const pending = useRef(new Set<number>());
  const downloadAttachment = async (file: LetterAttachment & { href: string }) => {
    if (pending.current.has(file.ID)) return;
    pending.current.add(file.ID);
    setDownloadingIds(current => [...current, file.ID]);
    try {
      const response = await fetch(file.href);
      if (!response.ok) throw new Error('Download non riuscito');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.nome;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch {
      toast.error('Impossibile scaricare allegato.');
    } finally {
      pending.current.delete(file.ID);
      setDownloadingIds(current => current.filter(id => id !== file.ID));
    }
  };
  const normalized = attachments.map((file) => ({
    ...file,
    href: /^https?:\/\//i.test(file.path.trim()) ? file.path.trim() : `https://${file.path.trim().replace(/^\/\//, "")}`,
  }));

  return (
    <div className="user-footer">
      <div>
        <DashboardSvgIcon iconId="attchment" />
        <span className="f-light">{"Attachments"}</span>
      </div>
      <div className="d-inline-block">
        {normalized.map((file) => (
          <div className="attchment-file common-flex" key={file.ID}>
            <div className="common-flex align-items-center">
              <Image src={dynamicImage(`email-template/pdfs.png`)} alt="file" />
              <div className="d-block">
                <P>{file.nome}</P>
                <P className="f-light">{file.href}</P>
              </div>
            </div>
            <button type="button" className="btn btn-link" disabled={downloadingIds.includes(file.ID)} onClick={() => downloadAttachment(file)} title={`Scarica ${file.nome}`} aria-label={`Scarica ${file.nome}`}>
              <i className={downloadingIds.includes(file.ID) ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-download"} aria-hidden="true" />
            </button>
          </div>
        ))}
        {/* {normalized.length === 0 && (
          <P className="f-light mb-2">No attachments</P>
        )} */}
      </div>
      {/* <div className="toolbar-box">
        <SimpleMdeReact placeholder={"Rispondi al messaggio.."}   options={{
          spellChecker: false
        }}/>
      </div>
      <div className="send-btn d-flex justify-content-end">
          <Btn color='primary'>{'Send'}<i className="fa-solid fa-paper-plane" /></Btn>
      </div> */}
    </div>
  );
}
